import { cn } from "@src/lib/utils";
import type { PromptInputToolsProps } from "./PromptInputToolsProps";

export const PromptInputTools = ({
  className,
  ...props
}: PromptInputToolsProps) => (
  <div className={cn("flex items-center gap-1", className)} {...props} />
);
